export default function log({ next, to }) {
  return next()
}
